import CreateEditPrivacyPolicyTemplate from "@/app/app-shared/privacy-policy/create-edit-privacy-policy-template";
import { ESiteContentType } from "@/utilities/enums/SiteContent";

export default function PrivacyPolicyPage() {
  return (
    <div>
      <CreateEditPrivacyPolicyTemplate
        contentType={ESiteContentType.PRIVACT_POLICY}
      />
    </div>
  );
}
